import {
  Box,
  Button,
  InputLabel,
  makeStyles,
  OutlinedInput,
  Typography,
} from "@material-ui/core";
import { ErrorMessage, Field, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { authorFormSchema } from "./signUpFormSchema";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { backend } from "../../../api";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import RegisterModal from "./RegisterModal";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    padding: "20px 0",
    margin: "15px 0",
  },
  formHeading: {
    fontWeight: "550",
    width: "90%",
    margin: "10px auto",
  },
  form: {
    margin: "20px auto",
    width: "90%",
  },
  fieldLabel: {
    color: theme.palette.secondary.light,
    marginBottom: "8px",
    fontSize: "15px",
    fontWeight: 500,
  },
  inputField: {
    padding: "10px",
    borderRadius: "2px",
  },
  btn: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.secondary.light,
    minWidth: "110px",
    margin: "10px 0",
    fontSize: "16px",
    height: "100%",
    fontWeight: "600",
    borderRadius: "2px",
    padding: "10px 10px",
    "&:hover": {
      backgroundColor: theme.palette.secondary.light,
      color: theme.palette.primary.main,
    },
  },
  roleItem: {
    padding: "10px 10px",
    cursor: "pointer",
  },
}));

function AuthorForm() {
  const [editModal, setEditModal] = useState(true);
  useEffect(() => {
    setEditModal(true);
  }, []);
  const classes = useStyles();
  const history = useHistory();
  const handleFormSubmit = (values) => {
    const newAuthor = {
      name: values.name,
      email: values.email,
      role: "author",
      password: values.password,
      phone_number: values.contact,
      author_biography: values.biography,
      book_proposal: {
        teaser: values.booksInfo,
      },
    };
    backend
      .post("/author/create", newAuthor)
      .then((res) => {
        Swal.fire({
          title: "Congratulations",
          icon: "success",
          confirmButtonText: "OK",
          text: res.data.message,
        }).then((result) => {
          if (result.isConfirmed) {
            history.push("/login");
          }
        });
      })
      .catch((err) => {
        if (err.response) {
          toast.error(err.response.data.message);
        } else {
          toast.error(err.message);
        }
      });
  };
  return (
    <div>
      <h2 className={classes.formHeading}>Create Account as Author</h2>
      <Formik
        initialValues={{
          name: "",
          email: "",
          password: "",
          confirmPassword: "",
          contact: "",
          biography: "",
          booksInfo: "",
        }}
        onSubmit={(values) => handleFormSubmit(values)}
        validationSchema={authorFormSchema}
      >
        {({ errors,  values, handleChange, setFieldValue }) => {
          return (
            <Form className={classes.form}>
              <Box mb={2}>
                <InputLabel className={classes.fieldLabel}>Name</InputLabel>
                <Field
                  type="text"
                  name="name"
                  as={OutlinedInput}
                  fullWidth
                  error={errors.name}
                  className={classes.inputField}
                />
                <ErrorMessage name="name">
                  {(error) => (
                    <Typography variant="subtitle2" color="error">
                      {error}
                    </Typography>
                  )}
                </ErrorMessage>
              </Box>
              <Box mb={2}>
                <InputLabel className={classes.fieldLabel}>Email</InputLabel>
                <Field
                  type="email"
                  name="email"
                  as={OutlinedInput}
                  fullWidth
                  error={errors.email}
                  className={classes.inputField}
                />
                <ErrorMessage name="email">
                  {(error) => (
                    <Typography variant="subtitle2" color="error">
                      {error}
                    </Typography>
                  )}
                </ErrorMessage>
              </Box>
              <Box mb={2}>
                <InputLabel className={classes.fieldLabel}>
                  Contact No.
                </InputLabel>
                <PhoneInput
                  value={values.contact}
                  type="text"
                  name="contact"
                  className={classes.inputField}
                  inputProps={{
                    name: "contact",
                    required: true,
                    autoFocus: true,
                  }}
                  onChange={(value, country, e, formattedValue) => {
                    // handleChange(value)
                    setFieldValue("contact", value);
                  }}
                  containerStyle={{
                    width: "100%",
                  }}
                  inputStyle={{
                    width: "100%",
                    padding: "20px 40px",
                  }}
                />
                <ErrorMessage name="contact">
                  {(error) => (
                    <Typography variant="subtitle2" color="error">
                      {error}
                    </Typography>
                  )}
                </ErrorMessage>
              </Box>
              <Box mb={2}>
                <InputLabel className={classes.fieldLabel}>
                  Biography as a Writer
                </InputLabel>
                <Field
                  type="text"
                  multiline
                  rows={5}
                  name="biography"
                  as={OutlinedInput}
                  fullWidth
                  error={errors.biography}
                  className={classes.inputField}
                />
                <ErrorMessage name="biography">
                  {(error) => (
                    <Typography variant="subtitle2" color="error">
                      {error}
                    </Typography>
                  )}
                </ErrorMessage>
              </Box>
              <Box mb={2}>
                <InputLabel className={classes.fieldLabel}>
                  Teaser of the Books you want to publish
                </InputLabel>
                <Field
                  type="text"
                  multiline
                  rows={3}
                  name="booksInfo"
                  as={OutlinedInput}
                  fullWidth
                  error={errors.booksInfo}
                  className={classes.inputField}
                />
                <ErrorMessage name="booksInfo">
                  {(error) => (
                    <Typography variant="subtitle2" color="error">
                      {error}
                    </Typography>
                  )}
                </ErrorMessage>
              </Box>
              <Box mb={2}>
                <InputLabel className={classes.fieldLabel}>Password</InputLabel>
                <Field
                  type="password"
                  name="password"
                  as={OutlinedInput}
                  fullWidth
                  error={errors.password}
                  className={classes.inputField}
                />
                <ErrorMessage name="password">
                  {(error) => (
                    <Typography variant="subtitle2" color="error">
                      {error}
                    </Typography>
                  )}
                </ErrorMessage>
              </Box>
              <Box mb={2}>
                <InputLabel className={classes.fieldLabel}>
                  Confirm Password
                </InputLabel>
                <Field
                  type="password"
                  name="confirmPassword"
                  as={OutlinedInput}
                  fullWidth
                  error={errors.confirmPassword}
                  className={classes.inputField}
                />
                <ErrorMessage name="confirmPassword">
                  {(error) => (
                    <Typography variant="subtitle2" color="error">
                      {error}
                    </Typography>
                  )}
                </ErrorMessage>
              </Box>
              <Box align="right">
                <Button type="submit" className={classes.btn}>
                  Sign Up
                </Button>
              </Box>
            </Form>
          );
        }}
      </Formik>
      <RegisterModal
        visible={editModal}
        closeModal={() => setEditModal(false)}
      />
    </div>
  );
}

export default AuthorForm;
